import { render, staticRenderFns } from "./providePay.vue?vue&type=template&id=8b5e6022&scoped=true"
import script from "./providePay.vue?vue&type=script&lang=js"
export * from "./providePay.vue?vue&type=script&lang=js"
import style0 from "./providePay.vue?vue&type=style&index=0&id=8b5e6022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5e6022",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PZPopup: require('/drone/src/components/PZPopup/PZPopup.vue').default})
